import React, { useState } from 'react';
import RowLevelSecurity from './RowLevelSecurity';
import ColumnLevelSecurity from '../ColumnLevelSecurity/ColumnLevelSecurity';
import { Divider } from '@mui/material';
import Impersonation from './Impersonation';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';

interface SecurityRule {
  id: number;
  column: string;
  condition: string;
  value: string;
}

const Security = () => {
  const { chartControls, tabTileProps, chartProperties, chartFilterGroup, businessType } =
    useSelector((state: RootState) => {
      return {
        chartProperties: state.chartProperties,
        tabTileProps: state.tabTileProps,
        chartControls: state.chartControls,
        chartFilterGroup: state.chartFilterGroup,
        businessType: state.isLogged.businessType,
      };
    });

  var propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
  const [rules, setRules] = useState<SecurityRule[]>([]);

  const addRule = () => {
    const newRule: SecurityRule = {
      id: Date.now(),
      column: '',
      condition: '',
      value: '',
    };
    setRules([...rules, newRule]);
  };

  const updateRule = (id: number, field: keyof SecurityRule, value: string) => {
    setRules((prevRules) =>
      prevRules.map((rule) => (rule.id === id ? { ...rule, [field]: value } : rule)),
    );
  };

  const deleteRule = (id: number) => {
    setRules((prevRules) => prevRules.filter((rule) => rule.id !== id));
  };

  const handleChartDimensionsSelectChange = (event: any) => {
    // setSelectedDimensions(event.target.value);
    // handleUpdateFormat(
    //   "selectedMeasure",
    //   {
    //     name: event.target.value?.displayname,
    //     uId: event.target.value?.uId,
    //   },
    //   "labelFormats"
    // );
    // if (!formatObject.measureFormats[event.target.value?.uId]) {
    //   handleUpdateFormat(
    //     "measureFormats",
    //     {
    //       ...chartControls.properties[propKey].formatOptions.labelFormats
    //         .measureFormats,
    //       [event.target.value?.uId]: {
    //         formatValue: "Number",
    //         currencySymbol: "$",
    //         enableRounding: true,
    //         roundingDigits: 1,
    //         numberSeparator: "Abbrev",
    //       },
    //     },
    //     "labelFormats"
    //   );
    // }
  };

  return (
    <>
      {businessType !== 'enterprise' ? (
        <div style={{ marginTop: '10px', padding: '8px' }}>
          <div
            style={{
              fontSize: '12px',
              // color: iconColor === '#ffffff' ? '#b9b4b4ff' : '#484848',
              // backgroundColor: tabAreaBackgroundColor,
              padding: '10px',
              borderRadius: '4px',
              border: '1px solid #ddd',
            }}
          >
            Security Chart Control features like Row Level and Column Level Security are available
            for Enterprise version only. You can upgrade to Enterprise version to enjoy these
            features.
          </div>
        </div>
      ) : (
        <>
          <RowLevelSecurity
            propKey={propKey}
            chartProperties={chartProperties}
            chartControls={chartControls}
            chartFilterGroup={chartFilterGroup}
          />
          <Divider sx={{ margin: '0px 10px' }} />
          <ColumnLevelSecurity
            propKey={propKey}
            chartProperties={chartProperties}
            chartControls={chartControls}
            chartFilterGroup={chartFilterGroup}
          />
          <Divider sx={{ margin: '0px 10px' }} />
          <Impersonation propKey={propKey} chartControls={chartControls} />
        </>
      )}
    </>
  );
};

export default Security;
